import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';

export const PlayerAreaContainer = styled.div<{ colors: ColormapInterface }>`
  height: 100vh;
  width: 100vw;
  background-color: ${({ colors }) => colors.playerBackground};
`;
PlayerAreaContainer.displayName = 'PlayerAreaContainer';
